import { render, staticRenderFns } from "./mbSystemfeatures.vue?vue&type=template&id=10557562&scoped=true&"
import script from "./mbSystemfeatures.vue?vue&type=script&lang=js&"
export * from "./mbSystemfeatures.vue?vue&type=script&lang=js&"
import style0 from "./mbSystemfeatures.vue?vue&type=style&index=0&id=10557562&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10557562",
  null
  
)

export default component.exports